import React, { useState } from 'react';
import { HomePage } from './pages/HomePage';
import { ReferralPage } from './pages/ReferralPage';
import { GreenLinesBackground } from './components/GreenLinesBackground';
export function App() {
  const [showReferral, setShowReferral] = useState(false);
  return <div className="relative min-h-screen overflow-hidden" data-id="element-0">
      <GreenLinesBackground data-id="element-1" />
      <div className="relative z-10" data-id="element-2">
        {showReferral ? <ReferralPage onBack={() => setShowReferral(false)} data-id="element-3" /> : <HomePage onRefer={() => setShowReferral(true)} data-id="element-4" />}
      </div>
    </div>;
}